module.exports = __webpack_public_path__ + "img/activityVisitors.3038aefe.png";